import { gql } from '@apollo/client';

export const LOGIN = gql`
   mutation LoginWithEmailPassword($body: LoginEmailPasswordInput!) {
    loginWithEmailPassword(body: $body) {
        expiry {
            expiresAt
            expiresBy
        }
        message
        token {
            accessToken
            accessTokenExpiresIn
            refreshToken
            refreshTokenExpiresIn
        }
        user {
            _id
            cometAuthToken
            email
            loginFlowType
            loginType
            status
            profileImageUrl
            enabled2FA
        }
    }
}
`;

export const REGISTER = gql`
    mutation ($input: CreateAdminDTO!) {
        register(input: $input) {
            _id
            name
            email
            status
            role
            phone
        }
    }
`;

export const FORGOT_PASSWORD = gql`
   mutation ForgotPassword($body: ForgetPasswordDto!) {
        forgotPassword(body: $body) {
            message
        }
    }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($body: ResetPasswordDTO!) {
    resetPassword(body: $body) {
        message
    }
}
`;

export const VERIFY_TOKEN = gql`
mutation VerifyWebAppToken($input: ResetPasswordDTO!) {
  verifyWebAppToken(input: $input)
}
`;

export const APP_USER_RESET_PASSWORD = gql`
    mutation ResetPassword($body: ResetPasswordDTO!) {
        resetPassword(body: $body) {
            message
        }
    }
`;

export const CHANGE_PASSWORD = gql`
   mutation ChangePassword($body: ChangePasswordInput!) {
        changePassword(body: $body) {
            message
        }
    }
`;

export const REFRESH_TOKEN = gql`
    mutation RefreshToken($refreshToken: String!) {
        refresh(refreshToken: $refreshToken) {
            accessToken
            refreshToken
        }
    }
`;

export const CODE_VERIFICATION = gql`
    mutation VerifyEmail($body: VerifyEmailInput!) {
        verifyEmail(body: $body) {
            expiry {
                expiresAt
                expiresBy
            }
            message
            token {
                accessToken
                accessTokenExpiresIn
                refreshToken
                refreshTokenExpiresIn
            }
            user {
                _id
                cometAuthToken
                email
                loginFlowType
                loginType
                status
            }
        }
    }
`;
export const RESEND_OTP_CODE = gql`
    mutation ($input: Resend2FAOtpCodeDTO!) {
        resendOtpCode(input: $input) {
            expiresBy
            expiresAt
        }
    }
`;

export const UPLOAD_PROFILE_IMAGE = gql`
    query GetPreSignedUrl($body: PreSignedUrlInput!) {
        getPreSignedUrl(body: $body) {
            message
            url
        }
    }
`;

export const VERIFY_OTP = gql`
    mutation ($token: String!) {
        verifyAuthOTP(token: $token) {
            message
            recoveryCodes
        }
    }
`;

export const VALIDATE_OTP = gql`
    mutation ($input: validateAuthOTPInput!) {
        validateAuthOTP(input: $input) {
            message
            user {
                _id
                email
                enabled2FA
            }
            token {
                accessToken
                refreshToken
            }
        }
    }
`;

export const AUTH_OTP_DISABLE = gql`
    mutation ($token: String!) {
        disableAuthOTP(token: $token)
    }
`;

export const VERIFY_RECOVERY_CODE = gql`
  mutation VerifyRecoveryCodes($input: VerifyRecoveryCode!) {
    verifyRecoveryCodes(input: $input) {
      message
      user {
        _id
        email
        enabled2FA
      }
      token {
        accessToken
        refreshToken
      }
    }
  }
`;

export const RESET_AUTHENTICATOR_APP = gql`
  mutation ResetAuthenticatorApp($input: ResendAuthenticatorAppDTO!) {
    resetAuthenticatorApp(input: $input) {
      message
    }
  }
`;

export const VERIFY_RESET_AUTHENTICATOR_APP = gql`
  mutation ConfirmResetAuthenticatorApp($input: Reset2FACodeVerificationDTO!) {
    confirmResetAuthenticatorApp(input: $input) {
      message
      user {
        _id
        email
        enabled2FA
      }
      token {
        accessToken
        refreshToken
      }
    }
  }
`;
